export const initTabSystem = () => {
	// ページ内のすべての「タブグループ」を探す
	const tabGroups = document.querySelectorAll(".c-tab-grid"); // ボタンの親

	tabGroups.forEach((group) => {
		const tabBtns = group.querySelectorAll(".c-tab-btn");

		// ★ここが変更点：ボタンの親の次にある .c-tab-body 内のパネルを探す想定
		// 構造に合わせて適宜親要素を取得してください
		const container = group.nextElementSibling; // .c-tab-body
		if (!container) return;

		const panels = container.querySelectorAll(".js-tab-panel");

		tabBtns.forEach((btn) => {
			btn.addEventListener("click", (e) => {
				// リンク(aタグ)ならページ遷移させる（アーカイブページ用）
				if (btn.tagName === "A") return;

				e.preventDefault();

				// 1. ボタンのアクティブ切り替え
				tabBtns.forEach((b) => b.classList.remove("is-active"));
				btn.classList.add("is-active");

				// 2. ターゲットID取得
				const targetKey = btn.getAttribute("data-target"); // "all", "topics" 等
				const targetPanelId = `panel-${targetKey}`;

				// 3. パネルの切り替え
				panels.forEach((panel) => {
					if (panel.id === targetPanelId) {
						panel.classList.add("is-active-panel");
					} else {
						panel.classList.remove("is-active-panel");
					}
				});
			});
		});
	});
};
